<script setup lang="ts">
import { LoaderCircleIcon } from '@lucide/vue'
</script>

<template>
  <LoaderCircleIcon class="animate-spin opacity-70" :size="20"/>
</template>

<style scoped></style>
